import { CallAPIPostPromise } from "Common/commaon";
import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import React, { useEffect, useState } from "react";
import { getDecodeId } from "slices/userProfile/thunk";
import contrctrLabr from '../../../../../src/assets/images/contractr-labor.jpg'
import { AlertCircle, CheckCircle2, Mail, Phone, Search, UserPlus, UsersRound, X } from "lucide-react";
interface Contractor {
  id: number;
  user_first_name: string;
  user_last_name: string;
  user_email: string;
  user_phone?: string;
  user_type?: string;
  ua_user_id: number;
  ua_profile_pic: string;
  ua_cover_pic?: string;
  ua_description: string;
  ua_skills?: string; // JSON string
  ua_work_availbility?: string; // JSON string
  ua_state?: string;
  ua_city?: string;
  ua_country?: string;
  ua_zip_code?: string;
  ua_address?: string;
  ua_exp?: string;
  ua_work_hours?: string;
  ua_completed?: string;
  ua_social_url?: string; // JSON string
}


interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  status: string;
  handleSubmitSearch: (contractor: any) => void;
}

export default function ContractorModal({
  isOpen,
  onClose,
  status,
  handleSubmitSearch,
}: ModalProps) {
  const [contractor, setContractor] = useState<Contractor | null>(null);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error,setError] = useState("")
  const decodedToken = decodeJwt();

  const userEmail = decodedToken ? decodedToken.email : "";
  const parsedSkills = (() => {
    if (!contractor?.ua_skills) return [];
    try {
      const skills = JSON.parse(contractor.ua_skills);
      return Array.isArray(skills) ? skills : [];
    } catch {
      return [];
    }
  })();

  useEffect(()=>{
    if(isOpen){
     setContractor(null)
     setError("")
     setEmail("")
    }
     },[isOpen])
  if (!isOpen) return null;

  const handleSearch = async () => {
    if (!email) return;
    if(userEmail ===email){
      setError("You can't add yourselef as subcontractor")
setTimeout(() => {
        setError("")
}, 5000);
return;
    }
    setLoading(true);
    setContractor(null);
    CallAPIPostPromise("/user/getSignleContractor",{
      email:email
    }).then((res:any)=>{
    if(res?.data){
      setContractor(res.data[0])
    }
    }).catch(()=>{
      setError("Not found any sub contractor linked with this email")
      setTimeout(() => {
              setError("")
      }, 5000);
    }).finally(()=>{
      setLoading(false)
    })
  };


//test
  return (
    <div className="tailwind-prefix">
 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-3">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[92vh] overflow-hidden relative flex flex-col">
        <div className="border-b border-gray-200 bg-gray-50 px-4 py-4 sm:px-5">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-start gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
                <UsersRound className="h-5 w-5" />
              </div>
              <div>
                <div className="text-lg font-semibold text-gray-900">Add Registered Subcontractor</div>
                <div className="mt-1 text-sm text-gray-600">
                  Search by email, verify the profile, then attach them to this contract.
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rounded-md border border-gray-200 bg-white p-2 text-gray-500 hover:bg-gray-50 hover:text-gray-900"
              onClick={onClose}
              aria-label="Close"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 sm:p-5 space-y-4">
          <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
            <label className="mb-2 block text-sm font-medium text-gray-700">Subcontractor email</label>
            <div className="flex flex-col sm:flex-row gap-2">
              <div className="app-icon-field flex-1">
                <Mail className="app-field-icon" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  }}
                  placeholder="name@example.com"
                  className="w-full rounded-lg border border-gray-300 py-2.5 pl-9 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <button
                className="inline-flex items-center justify-center gap-2 rounded-lg border-0 bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
                onClick={handleSearch}
                disabled={loading || !email}
                type="button"
              >
                {loading ? (
                  <div className="h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin" />
                ) : (
                  <Search className="h-4 w-4" />
                )}
                {loading ? "Searching..." : "Search"}
              </button>
            </div>
          </div>

          {loading  && (
            <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
              <div className="animate-pulse space-y-4">
                <div className="flex items-center gap-3">
                  <div className="h-14 w-14 rounded-full bg-gray-100" />
                  <div className="flex-1 space-y-2">
                    <div className="h-4 w-1/2 rounded bg-gray-100" />
                    <div className="h-3 w-1/3 rounded bg-gray-100" />
                  </div>
                </div>
                <div className="h-3 w-full rounded bg-gray-100" />
                <div className="h-3 w-2/3 rounded bg-gray-100" />
              </div>
            </div>
          )}
        
          {error && <div className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              <AlertCircle className="mt-0.5 h-4 w-4 flex-none" />
              <span>{error}</span>
            </div>}

          {!loading && !contractor && !error && (
            <div className="rounded-xl border border-dashed border-gray-300 bg-gray-50 p-6 text-center">
              <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-lg bg-white text-gray-600 shadow-sm">
                <Search className="h-6 w-6" />
              </div>
              <div className="text-base font-medium text-gray-900">Search for a registered subcontractor</div>
              <div className="mx-auto mt-1 max-w-md text-sm text-gray-600">
                Enter the subcontractor email used in The Tradesmen's Collective. Their profile will appear here before you add them.
              </div>
            </div>
          )}

    
{contractor && (
  <div
    key={contractor.id}
    className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
  >
    <div className="h-20 bg-gradient-to-r from-blue-50 via-white to-green-50" />
    <div className="-mt-10 p-4 sm:p-5">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div className="flex items-end gap-4">
          <img
            src={contractor.ua_profile_pic || contrctrLabr}
            alt={contractor.user_first_name}
            className="h-20 w-20 rounded-xl border-4 border-white bg-white object-cover shadow-md"
          />
          <div className="pb-1">
            <div className="text-lg font-semibold text-gray-900">
              {contractor.user_first_name} {contractor.user_last_name}
            </div>
            <div className="mt-1 inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium capitalize text-green-700">
              <CheckCircle2 className="mr-1 h-3.5 w-3.5" />
              {contractor.user_type || "subcontractor"}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
          <div className="flex items-center gap-2 text-xs font-medium uppercase text-gray-500">
            <Mail className="h-3.5 w-3.5" />
            Email
          </div>
          <div className="mt-1 break-all text-sm font-medium text-gray-900">{contractor.user_email || "-"}</div>
        </div>
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
          <div className="flex items-center gap-2 text-xs font-medium uppercase text-gray-500">
            <Phone className="h-3.5 w-3.5" />
            Phone
          </div>
          <div className="mt-1 text-sm font-medium text-gray-900">{contractor.user_phone || "-"}</div>
        </div>
      </div>

      <div className="mt-4 rounded-lg border border-gray-200 bg-white p-3">
        <div className="text-xs font-medium uppercase text-gray-500">Profile Summary</div>
        <div className="mt-1 text-sm leading-relaxed text-gray-700">
          {contractor.ua_description || "No profile summary added yet."}
        </div>
      </div>

    {parsedSkills.length > 0 && (
      <div className="mt-4">
        <h4 className="mb-2 text-sm font-semibold text-gray-900">Skills</h4>
        <div className="flex flex-wrap gap-2">
          {parsedSkills.map(
            (skill: { value: string; label: string }, i: number) => (
              <span
                key={i}
                className="rounded-md bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700"
              >
                {skill.label}
              </span>
            )
          )}
        </div>
      </div>
    )}

    <button
    type="button"
    disabled={loading}
      className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-lg border-0 bg-gray-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-gray-800 disabled:opacity-60"
      onClick={() => {
        setLoading(true)
        CallAPIPostPromise("/subcontractor/create-subcontractor", {
          subContractorFirstname: contractor.user_first_name,
          subContractorLastName: contractor.user_last_name,
          subContractorEmail: contractor.user_email,
          subContractorPhone: contractor.user_phone || "",
          subContractorStatus: true,
          contractorId: getDecodeId(),
          InternalContractorID: contractor.id,
        }).then(() => {
          handleSubmitSearch(contractor.id)
          onClose();
        }).catch((e:any)=>{
          console.log(e)
        }).finally(()=>{
          setLoading(false)
        })
      }}
    >
      <UserPlus className="h-4 w-4" />
      {loading?"Adding...":"Add as Subcontractor"}
      
    </button>
    </div>
  </div>
)}
        </div>
      </div>
    </div>
    </div>
   
  );
}
